import { render, staticRenderFns } from "./installer-maintain-order-details.vue?vue&type=template&id=568f23a1&scoped=true&"
import script from "./installer-maintain-order-details.vue?vue&type=script&lang=js&"
export * from "./installer-maintain-order-details.vue?vue&type=script&lang=js&"
import style0 from "./installer-maintain-order-details.vue?vue&type=style&index=0&id=568f23a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f23a1",
  null
  
)

export default component.exports